import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate';
export default createStore({
  state: {
    zrctoken: '',
  },
  getters: {
  },
  mutations: {
    SetZrctoken(state, data) {
      state.zrctoken = data
    }
  },
  
  plugins: [
    createPersistedState(
      {
        // 自定义key
        key: 'zrctoken',
        // 缓存形式为sessionStorage
        storage: sessionStorage,
        // 将state里面的num1值进行缓存
        paths: ['zrctoken']
      }
    )
  ],
  actions: {
  },
  modules: {
  }
})
